/**
 * Component: sa-product-img-with-text
 * Description: Minimal Web Component to support lifecycle without external deps.
 */
if (!customElements.get('sa-product-img-with-text')) {
  class SaProductImgWithText extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Scope queries within the component
      this.container = this.querySelector('.sa-product-img-with-text__container');
      this.left = this.querySelector('.sa-product-img-with-text__left');
      this.right = this.querySelector('.sa-product-img-with-text__right');

      // Read layout info via class (optional enhancement could use data-*)
      this.isReversed = this.classList.contains('sa-product-img-with-text--reverse');
    }

    disconnectedCallback() {
      // Cleanup if necessary
    }
  }

  customElements.define('sa-product-img-with-text', SaProductImgWithText);
}

